angular.module('vrm.components').directive('vrmCommandK', ['$location', '$state', '$stateParams', '$timeout', 'locale', 'vrmConfig', 'InstallationsService', '$rootScope', 'AppearanceService',
    function($location, $state, $stateParams, $timeout, locale, vrmConfig, InstallationsService, $rootScope, AppearanceService ) {
      return {
        restrict: 'E',
        scope: {},
        link: function(scope, element) {
          // Import web component
          const commandK = require('@vrm/command-k');
          commandK.register();
          
          // Element reference
          const commandElement = element[0];
          
          // State
          let isDarkMode = AppearanceService.isDarkModeActive();
          
          function updateVisibility() {
            const shouldShow = $location.path().includes('/installation/');
            element.css('display', shouldShow ? '' : 'none');
            // Disable the element if it's not visible to prevent it from being reacting to cmd+K events
            commandElement.setAttribute('disabled', shouldShow ? 'false' : 'true');
            
            if (shouldShow) {
              updateTheme();
            }
          }
          
          function updateTheme() {
            commandElement.setAttribute('theme', isDarkMode ? 'dark' : 'light');
          }
          
          function setupThemeObserver() {
            const themeObserver = new MutationObserver(() => {
              const newIsDarkMode = document.documentElement.classList.contains('dark');
              if (isDarkMode !== newIsDarkMode) {
                isDarkMode = newIsDarkMode;
                updateTheme();
              }
            });
            
            themeObserver.observe(document.documentElement, { attributes: true });
            scope.$on('$destroy', () => themeObserver.disconnect());
          }

          function getTranslations() {
            return {
              dashboard: locale.getString('nav.dashboard', null, true) || "Dashboard",
              advanced: locale.getString('nav.advanced', null, true) || 'Advanced',
              alarmLogs: locale.getString('nav.alarm_logs', null, true) || 'Alarm logs',
              deviceList: locale.getString('nav.system_overview', null, true) || 'Device list',
              eventLogs: locale.getString('nav.event_logs', null, true) || 'Event logs',
              generalSettings: locale.getString('nav.settings', null, true) || 'Settings',
              users: locale.getString('nav.users', null, true) || 'Users',
              alarmRules: locale.getString('nav.alarm_rules', null, true) || 'Alarm rules',
              installationOverview: locale.getString('nav.installation_overview', null, true) || 'All installations',
              search: locale.getString('general.search', null, true) || 'Search',
              select: locale.getString('general.select', null, true) || 'Select',
              open: locale.getString('general.open', null, true) || 'Open',
              close: locale.getString('common.close', null, true) || 'Close',
              navigation: locale.getString('nav.navigation', null, true) || 'Navigation',
              fleetMonitor: locale.getString('nav.fleet_monitor', null, true) || 'Fleet monitor',
            };
          }

          function setTranslations() {
            const translations = getTranslations();
            commandElement.setAttribute('translations', JSON.stringify(translations));
          }
          
          function handleSelect(event) {
            const selectedCommand = event.detail[0];
            
            const routes = {
              "dashboard": `base.installation.dashboard`,
              "advanced": `base.installation.advanced`,
              "alarm_logs": `base.installation.alarmlogs`,
              "device_list": `base.installation.overview`, 
              "event_logs": `base.installation.eventlogs`,
              "general_settings": `base.installation.settings.general`,
              "users": `base.installation.settings.users`,
              "alarm_rules": `base.installation.settings.alarms`,
              "installation_overview": `base.installation-overview`,
              "fleet_monitor": `base.fleet-monitor`,
            };
            
            if (routes[selectedCommand]) {
              $state.go(routes[selectedCommand], {id: $stateParams.id});
            }
          }

          async function shouldShowFleetMonitor () {
            const threshold = vrmConfig.fleetMonitorMenuThreshold || 2;
            
            await InstallationsService.loading;
            const siteCount = InstallationsService.installations.length || 0;
            
            const isDemo = $rootScope.userState.isDemo;

            return isDemo || siteCount >= threshold;
          }

          async function handleFleetMonitor() {
            const shouldShow = await shouldShowFleetMonitor();
            commandElement.setAttribute('show-fleet-monitor', shouldShow);
          }
          
          // Initialize
          element.on('select', handleSelect);
          updateTheme();
          setupThemeObserver();
          $timeout(updateVisibility, 0);
          handleFleetMonitor();
          // Load translations
          locale.ready('nav', 'common', 'general').then(() => {
            setTranslations();
          });
          // Listen for language change events
          scope.$on('ngLocalizeLocaleChanged', () => {
            locale.ready('nav', 'common', 'general').then(() => {
              setTranslations();
            });
          });
          scope.$on('$locationChangeSuccess', updateVisibility);
          scope.$on('$destroy', () => element.off('select', handleSelect));
        }
      };
    }
  ]);